import React, { useState } from "react";
import {
  Card,
  Form,
  Button,
  Spinner,
  Alert,
  Badge,
  Table,
} from "react-bootstrap";
import {
  getInfoRegistrasiByNoDaftar,
  getCekPembayaran,
} from "../../services/api";

const PengajuanSHCekPengajuan = () => {
  const [noDaftar, setNoDaftar] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);
  const [loadingPembayaran, setLoadingPembayaran] = useState(false);
  const [pembayaranResult, setPembayaranResult] = useState(null);

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    try {
      return new Date(dateStr).toLocaleDateString("id-ID", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
    } catch {
      return dateStr;
    }
  };

  const SectionCard = ({ icon, title, children }) => (
    <div
      className="mb-4 rounded"
      style={{ border: "1px solid #e0e0e0", overflow: "hidden" }}
    >
      <div
        className="px-3 py-2 d-flex align-items-center gap-2"
        style={{ background: "#f5f7fa", borderBottom: "1px solid #e0e0e0" }}
      >
        <i className={`fas ${icon} text-primary`}></i>
        <span className="fw-semibold" style={{ fontSize: "0.9rem" }}>
          {title}
        </span>
      </div>
      <div className="p-3">{children}</div>
    </div>
  );

  const Field = ({ label, value }) => (
    <div className="mb-2">
      <span
        className="text-muted small d-block"
        style={{ fontSize: "0.75rem" }}
      >
        {label}
      </span>
      <span style={{ fontSize: "0.875rem" }}>{value || "-"}</span>
    </div>
  );

  const getStatusBadge = (status) => {
    if (!status) return <Badge bg="secondary">-</Badge>;
    const s = status.toLowerCase();
    if (s.includes("terbit") || s.includes("selesai"))
      return <Badge bg="success">{status}</Badge>;
    if (s.includes("proses") || s.includes("verif"))
      return <Badge bg="primary">{status}</Badge>;
    if (s.includes("tolak") || s.includes("batal"))
      return <Badge bg="danger">{status}</Badge>;
    if (s.includes("kirim") || s.includes("dokumen"))
      return (
        <Badge bg="warning" text="dark">
          {status}
        </Badge>
      );
    return <Badge bg="info">{status}</Badge>;
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    setError(null);
    setResult(null);
    if (!noDaftar) return setError("Masukkan Nomor Daftar terlebih dahulu.");
    try {
      setLoading(true);
      const resp = await getInfoRegistrasiByNoDaftar(noDaftar);
      const data = resp.data;
      // Accept both external SIHALAL format ({ status: 'success', data: {...} })
      // and local backend format ({ success: true, data: {...} }).
      const ok = data && (data.status === "success" || data.success === true);
      if (!ok) {
        setError("Data tidak ditemukan atau terjadi kesalahan pada API.");
        return;
      }

      const pengajuan = data.data?.pengajuan;
      if (!pengajuan) {
        setError("Format data tidak sesuai: pengajuan tidak ditemukan.");
        return;
      }

      // User is already authenticated to this LP3H system, so no need to verify id_lp
      // The external API will only return data that the authenticated user has access to

      setResult(data.data);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Gagal memuat data. Coba lagi.");
    } finally {
      setLoading(false);
    }
  };

  const handleCekPembayaran = async () => {
    setError(null);
    setPembayaranResult(null);
    if (!noDaftar) return setError("Masukkan Nomor Daftar terlebih dahulu.");
    try {
      setLoadingPembayaran(true);
      const resp = await getCekPembayaran(noDaftar);
      setPembayaranResult(resp.data);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Gagal cek pembayaran.");
    } finally {
      setLoadingPembayaran(false);
    }
  };

  return (
    <div className="page-content">
      <div
        className="page-header-banner"
        style={{
          background:
            "linear-gradient(135deg, var(--primary-color) 0%, var(--primary-hover) 50%, var(--primary-dark) 100%)",
        }}
      >
        <div className="page-header-content">
          <div className="page-header-left">
            <div className="page-header-icon">
              <i className="fas fa-clipboard-list"></i>
            </div>
            <div>
              <h1 className="page-header-title">Cek Pengajuan SH</h1>
              <p className="page-header-subtitle">
                Masukkan Nomor Daftar untuk menampilkan data registrasi
              </p>
            </div>
          </div>
        </div>
      </div>

      <Card className="mt-4">
        <Card.Body>
          {error && (
            <Alert variant="danger" onClose={() => setError(null)} dismissible>
              {error}
            </Alert>
          )}

          <Form onSubmit={handleSearch} className="mb-3">
            <Form.Group className="d-flex gap-2">
              <Form.Control
                type="text"
                placeholder="Masukkan No. Daftar (contoh: SH2025-1-1123801)"
                value={noDaftar}
                onChange={(e) => setNoDaftar(e.target.value)}
              />
              <Button type="submit" disabled={loading} variant="primary">
                {loading ? (
                  <>
                    <Spinner animation="border" size="sm" /> Cari...
                  </>
                ) : (
                  "Cari"
                )}
              </Button>
            </Form.Group>
          </Form>

          {result && (
            <div style={{ background: "#f8f9fa" }}>
              {/* header */}
              <div
                style={{
                  background:
                    "linear-gradient(135deg, var(--primary-color) 0%, var(--primary-hover) 50%, var(--primary-dark) 100%)",
                  color: "#fff",
                  padding: "12px 16px",
                }}
              >
                <div className="d-flex align-items-center gap-3">
                  <i className="fas fa-file-alt fa-lg"></i>
                  <div>
                    <h5 className="mb-0 fw-bold">
                      {result.pengajuan?.no_daftar || "Detail Registrasi"}
                    </h5>
                    <small style={{ opacity: 0.85 }}>
                      {result.pengajuan?.merek_dagang} —{" "}
                      {result.pengajuan?.nama_pu}
                    </small>
                  </div>
                  <div className="ms-auto d-flex align-items-center gap-2">
                    <Button
                      size="sm"
                      variant="light"
                      onClick={handleCekPembayaran}
                      disabled={loadingPembayaran}
                    >
                      {loadingPembayaran ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        "Cek Pembayaran"
                      )}
                    </Button>
                    {getStatusBadge(result.pengajuan?.status_reg)}
                  </div>
                </div>
              </div>

              <div className="p-3">
                {/* Informasi Pengajuan */}
                <SectionCard icon="fa-store" title="Informasi Pengajuan">
                  <div className="row g-2">
                    <div className="col-6 col-md-3">
                      <Field
                        label="No. Daftar"
                        value={result.pengajuan?.no_daftar}
                      />
                    </div>
                    <div className="col-6 col-md-3">
                      <Field
                        label="Tgl. Daftar"
                        value={formatDate(result.pengajuan?.tgl_daftar)}
                      />
                    </div>
                    <div className="col-6 col-md-3">
                      <Field
                        label="Jenis Daftar"
                        value={result.pengajuan?.jenis_daftar}
                      />
                    </div>
                    <div className="col-6 col-md-3">
                      <Field
                        label="No. Mohon"
                        value={result.pengajuan?.no_mohon}
                      />
                    </div>
                    <div className="col-6 col-md-3">
                      <Field
                        label="Lembaga"
                        value={
                          <div>
                            <div>{result.pengajuan?.nama_lembaga}</div>
                            {result.pengajuan?.nama_pendamping && (
                              <div
                                style={{ fontSize: "0.8rem", color: "#6c757d" }}
                              >
                                Pendamping: {result.pengajuan.nama_pendamping}
                              </div>
                            )}
                          </div>
                        }
                      />
                    </div>
                    <div className="col-6 col-md-3">
                      <Field
                        label="Status"
                        value={result.pengajuan?.status_reg}
                      />
                    </div>
                    <div className="col-6 col-md-3">
                      <Field
                        label="Skala Usaha"
                        value={result.pengajuan?.skala_usaha}
                      />
                    </div>
                    <div className="col-6 col-md-3">
                      <Field
                        label="Jenis Usaha"
                        value={
                          result.pengajuan?.jenis_usaha ||
                          result.pengajuan?.jenis_produk
                        }
                      />
                    </div>
                    <div className="col-6 col-md-3">
                      <Field
                        label="Kode Pos"
                        value={
                          result.pengajuan?.kode_pos_pu ||
                          result.pengajuan?.kode_pos
                        }
                      />
                    </div>
                    <div className="col-6 col-md-3">
                      <Field
                        label="Negara"
                        value={
                          result.pengajuan?.negara_pu ||
                          result.pengajuan?.negara
                        }
                      />
                    </div>
                  </div>
                </SectionCard>

                {/* Cek Pembayaran via SIHALAL */}
                {pembayaranResult && (
                  <SectionCard icon="fa-money-bill-wave" title="Cek Pembayaran">
                    <div className="table-responsive">
                      <Table size="sm" bordered className="mb-0">
                        <thead className="table-light">
                          <tr>
                            <th>Field</th>
                            <th>Value</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(() => {
                            const arr =
                              pembayaranResult.data ||
                              pembayaranResult.data ||
                              [];
                            const item =
                              Array.isArray(arr) && arr.length > 0
                                ? arr[0]
                                : null;
                            if (!item)
                              return (
                                <tr>
                                  <td colSpan={2}>
                                    Tidak ada data pembayaran.
                                  </td>
                                </tr>
                              );
                            return Object.entries(item)
                              .filter(([, v]) => v !== null && v !== undefined)
                              .map(([k, v]) => (
                                <tr key={k}>
                                  <td style={{ width: 240 }}>
                                    {k.replace(/_/g, " ")}
                                  </td>
                                  <td>
                                    {typeof v === "string" &&
                                    /T\d{2}:\d{2}:\d{2}/.test(v)
                                      ? formatDate(v)
                                      : v === ""
                                        ? "-"
                                        : typeof v === "object"
                                          ? JSON.stringify(v)
                                          : v}
                                  </td>
                                </tr>
                              ));
                          })()}
                        </tbody>
                      </Table>
                    </div>
                  </SectionCard>
                )}

                {/* Pelaku Usaha */}
                <SectionCard icon="fa-building" title="Data Pelaku Usaha">
                  <div className="row g-2">
                    <div className="col-6 col-md-4">
                      <Field
                        label="Nama PU"
                        value={result.pengajuan?.nama_pu}
                      />
                    </div>
                    <div className="col-6 col-md-4">
                      <Field
                        label="Merek Dagang"
                        value={result.pengajuan?.merek_dagang}
                      />
                    </div>
                    <div className="col-6 col-md-4">
                      <Field
                        label="Nama PJ"
                        value={result.pengajuan?.nama_pj}
                      />
                    </div>
                    <div className="col-6 col-md-4">
                      <Field
                        label="Email PJ"
                        value={
                          result.pengajuan?.email_pj || result.pengajuan?.email
                        }
                      />
                    </div>
                    <div className="col-6 col-md-4">
                      <Field
                        label="No. Kontak PJ"
                        value={
                          result.pengajuan?.no_kontak_pj ||
                          result.pengajuan?.no_kontak_pj ||
                          result.pengajuan?.no_telp
                        }
                      />
                    </div>
                    <div className="col-6 col-md-4">
                      <Field
                        label="No. Telp"
                        value={result.pengajuan?.no_telp}
                      />
                    </div>
                    <div className="col-12 col-md-8">
                      <Field
                        label="Alamat"
                        value={result.pengajuan?.alamat_pu}
                      />
                    </div>
                    <div className="col-6 col-md-2">
                      <Field
                        label="Kota/Kab"
                        value={result.pengajuan?.kota_pu}
                      />
                    </div>
                    <div className="col-6 col-md-2">
                      <Field
                        label="Provinsi"
                        value={result.pengajuan?.prov_pu}
                      />
                    </div>
                  </div>
                </SectionCard>

                {/* Produk */}
                {Array.isArray(result.produk) && result.produk.length > 0 && (
                  <SectionCard icon="fa-box" title="Produk">
                    <div className="table-responsive">
                      <Table
                        bordered
                        size="sm"
                        className="mb-0"
                        style={{ fontSize: "0.825rem" }}
                      >
                        <thead className="table-light">
                          <tr>
                            <th>#</th>
                            <th>Nama Produk</th>
                            <th>Jumlah Bahan</th>
                          </tr>
                        </thead>
                        <tbody>
                          {result.produk.map((p, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>{p.reg_prod_name || p.nama_produk || "-"}</td>
                              <td>{p.jumlah_bahan ?? "-"}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </SectionCard>
                )}

                {/* Bahan */}
                {Array.isArray(result.bahan) && result.bahan.length > 0 && (
                  <SectionCard
                    icon="fa-flask"
                    title={`Bahan (${result.bahan.length})`}
                  >
                    <div className="table-responsive">
                      <Table
                        bordered
                        size="sm"
                        className="mb-0"
                        style={{ fontSize: "0.8rem" }}
                      >
                        <thead className="table-light">
                          <tr>
                            <th>#</th>
                            <th>Nama Bahan</th>
                            <th>Kelompok</th>
                            <th>Jenis</th>
                            <th>Merek</th>
                            <th>Produsen</th>
                            <th>No. Sertifikat Halal</th>
                            <th>Tgl. Berlaku</th>
                          </tr>
                        </thead>
                        <tbody>
                          {result.bahan.map((b, i) => {
                            const jenisParts = (b.jenis_bahan || "").split("|");
                            return (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <td>{b.reg_nama_bahan}</td>
                                <td>{b.kelompok || "-"}</td>
                                <td>{jenisParts[1] || "-"}</td>
                                <td>{b.merek || "-"}</td>
                                <td>{b.produsen || "-"}</td>
                                <td>{b.no_sertifikat_halal || "-"}</td>
                                <td>{formatDate(b.tgl_berlaku_sertifikat)}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>
                  </SectionCard>
                )}

                {/* Pabrik */}
                {Array.isArray(result.pabrik) && result.pabrik.length > 0 && (
                  <SectionCard icon="fa-industry" title="Fasilitas Produksi">
                    <div className="table-responsive">
                      <Table
                        bordered
                        size="sm"
                        className="mb-0"
                        style={{ fontSize: "0.825rem" }}
                      >
                        <thead className="table-light">
                          <tr>
                            <th>Nama</th>
                            <th>Alamat</th>
                            <th>Kode Pos</th>
                            <th>Status Milik</th>
                          </tr>
                        </thead>
                        <tbody>
                          {result.pabrik.map((p, i) => (
                            <tr key={i}>
                              <td>{p.nama || "-"}</td>
                              <td>{p.alamat || "-"}</td>
                              <td>{p.kode_pos || p.kode_pos || "-"}</td>
                              <td>{p.nama_status || p.status_milik || "-"}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </SectionCard>
                )}

                {/* Aspek Legal */}
                {Array.isArray(result.aspek_legal) &&
                  result.aspek_legal.length > 0 && (
                    <SectionCard icon="fa-file-contract" title="Aspek Legal">
                      <div className="table-responsive">
                        <Table
                          bordered
                          size="sm"
                          className="mb-0"
                          style={{ fontSize: "0.825rem" }}
                        >
                          <thead className="table-light">
                            <tr>
                              <th>Jenis Surat</th>
                              <th>No. Surat</th>
                              <th>Tgl. Surat</th>
                              <th>Instansi Penerbit</th>
                              <th>Masa Berlaku</th>
                            </tr>
                          </thead>
                          <tbody>
                            {result.aspek_legal.map((a, i) => (
                              <tr key={i}>
                                <td>
                                  {a.jenis_surat ||
                                    a.jenis_surat_lainnya ||
                                    "-"}
                                </td>
                                <td>{a.no_surat || "-"}</td>
                                <td>{formatDate(a.tgl_surat)}</td>
                                <td>{a.instansi_penerbit || "-"}</td>
                                <td>{formatDate(a.masa_berlaku)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </SectionCard>
                  )}

                {/* Penyelia */}
                {Array.isArray(result.penyelia) &&
                  result.penyelia.length > 0 && (
                    <SectionCard icon="fa-user-shield" title="Penyelia Halal">
                      <div className="table-responsive">
                        <Table
                          bordered
                          size="sm"
                          className="mb-0"
                          style={{ fontSize: "0.825rem" }}
                        >
                          <thead className="table-light">
                            <tr>
                              <th>Nama</th>
                              <th>No. KTP</th>
                              <th>No. Sertifikat</th>
                              <th>Tgl. Sertifikat</th>
                              <th>No. SK</th>
                              <th>No. Kontak</th>
                            </tr>
                          </thead>
                          <tbody>
                            {result.penyelia.map((p, i) => (
                              <tr key={i}>
                                <td>{p.nama || "-"}</td>
                                <td>{p.no_ktp || "-"}</td>
                                <td>{p.no_sertifikat || "-"}</td>
                                <td>
                                  {formatDate(
                                    p.tgl_sertifikat || p.tgl_sertifikat,
                                  )}
                                </td>
                                <td>{p.no_sk || "-"}</td>
                                <td>{p.no_kontak || "-"}</td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </SectionCard>
                  )}

                {/* KBLI */}
                {Array.isArray(result.kbli) && result.kbli.length > 0 && (
                  <SectionCard icon="fa-tag" title="KBLI">
                    <div className="table-responsive">
                      <Table
                        bordered
                        size="sm"
                        className="mb-0"
                        style={{ fontSize: "0.825rem" }}
                      >
                        <thead className="table-light">
                          <tr>
                            <th>Kode KBLI</th>
                            <th>Nama KBLI</th>
                          </tr>
                        </thead>
                        <tbody>
                          {result.kbli.map((k, i) => (
                            <tr key={i}>
                              <td>{k.kbli || k.kode}</td>
                              <td>
                                {k.nama_kbli ||
                                  k.nama_kbli ||
                                  JSON.stringify(k)}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </SectionCard>
                )}

                {/* Sidang Fatwa */}
                {Array.isArray(result.sidang_fatwa) &&
                  result.sidang_fatwa.length > 0 && (
                    <SectionCard icon="fa-gavel" title="Sidang Fatwa">
                      <div className="table-responsive">
                        <Table
                          bordered
                          size="sm"
                          className="mb-0"
                          style={{ fontSize: "0.825rem" }}
                        >
                          <thead className="table-light">
                            <tr>
                              <th>Tanggal</th>
                              <th>Ketetapan</th>
                              <th>No. KH</th>
                              <th>Catatan</th>
                            </tr>
                          </thead>
                          <tbody>
                            {result.sidang_fatwa.map((s, i) => {
                              const tanggal =
                                s.tgl_sidang ||
                                s.tanggal ||
                                s.taken_date ||
                                s.date ||
                                null;
                              const ketetapan =
                                s.ketetapan ||
                                s.hasil ||
                                s.result ||
                                s.status_desc ||
                                "-";
                              const noKh =
                                s.no_kh || s.no_kh || s.no_berita_acara || "-";
                              const catatan =
                                s.catatan || s.keterangan || s.catatan2 || "-";
                              return (
                                <tr key={i}>
                                  <td>{formatDate(tanggal)}</td>
                                  <td>{ketetapan}</td>
                                  <td>{noKh}</td>
                                  <td>{catatan}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                    </SectionCard>
                  )}

                {/* Sertifikat */}
                {Array.isArray(result.sertifikat) &&
                  result.sertifikat.length > 0 && (
                    <SectionCard icon="fa-certificate" title="Sertifikat Halal">
                      <div className="table-responsive">
                        <Table
                          bordered
                          size="sm"
                          className="mb-0"
                          style={{ fontSize: "0.825rem" }}
                        >
                          <thead className="table-light">
                            <tr>
                              <th>No. Sertifikat</th>
                              <th>Tgl. Terbit</th>
                              <th>Tgl. Berlaku</th>
                            </tr>
                          </thead>
                          <tbody>
                            {result.sertifikat.map((s, i) => {
                              const no =
                                s.no_sert ||
                                s.no_sertifikat ||
                                s.no ||
                                s.no_sertifikat ||
                                s.filesert ||
                                "-";
                              const tglTerbit =
                                s.tgl_sert ||
                                s.tgl_terbit ||
                                s.create_on ||
                                null;
                              const tglBerlaku =
                                s.tgl_valid || s.tgl_berlaku || null;
                              return (
                                <tr key={i}>
                                  <td>{no}</td>
                                  <td>{formatDate(tglTerbit)}</td>
                                  <td>{formatDate(tglBerlaku)}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                    </SectionCard>
                  )}

                {/* Tracking */}
                {Array.isArray(result.tracking) &&
                  result.tracking.length > 0 && (
                    <SectionCard
                      icon="fa-history"
                      title={`Riwayat Tracking (${result.tracking.length})`}
                    >
                      <div style={{ position: "relative", paddingLeft: 28 }}>
                        <div
                          style={{
                            position: "absolute",
                            left: 9,
                            top: 8,
                            bottom: 8,
                            width: 2,
                            background: "#dee2e6",
                          }}
                        />
                        {result.tracking.map((t, i) => {
                          const s = (
                            t.status_desc ||
                            t.status ||
                            ""
                          ).toLowerCase();
                          let dotColor = "#6c757d";
                          if (s.includes("terbit") || s.includes("selesai"))
                            dotColor = "#198754";
                          else if (
                            s.includes("dikembalikan") ||
                            s.includes("batal")
                          )
                            dotColor = "#dc3545";
                          else if (
                            s.includes("proses") ||
                            s.includes("submitted")
                          )
                            dotColor = "#0d6efd";
                          else if (s.includes("kirim")) dotColor = "#ffc107";
                          return (
                            <div
                              key={t.log_id || i}
                              className="mb-3"
                              style={{ position: "relative" }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  left: -20,
                                  top: 4,
                                  width: 12,
                                  height: 12,
                                  borderRadius: "50%",
                                  background: dotColor,
                                  border: "2px solid #fff",
                                  boxShadow: `0 0 0 2px ${dotColor}`,
                                  zIndex: 1,
                                }}
                              />
                              <div className="d-flex align-items-center gap-2 flex-wrap mb-1">
                                <span
                                  className="fw-semibold"
                                  style={{
                                    fontSize: "0.85rem",
                                    color: dotColor,
                                  }}
                                >
                                  {t.status_desc || t.status}
                                </span>
                                <span
                                  className="text-muted"
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  <i className="fas fa-clock me-1"></i>
                                  {t.tanggal
                                    ? new Date(t.tanggal).toLocaleString(
                                        "id-ID",
                                      )
                                    : t.tgl || "-"}
                                </span>
                                <span
                                  className="text-muted"
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  <i className="fas fa-user me-1"></i>
                                  {t.userid || t.user || "-"}
                                </span>
                              </div>
                              {t.keterangan && (
                                <div
                                  className="p-2 rounded"
                                  style={{
                                    background: "#fff8f0",
                                    border: "1px solid #ffe0b2",
                                    fontSize: "0.8rem",
                                    whiteSpace: "pre-wrap",
                                    lineHeight: 1.5,
                                  }}
                                >
                                  {t.keterangan}
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </SectionCard>
                  )}
              </div>
            </div>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default PengajuanSHCekPengajuan;
